import React from 'react';

const PrivacyPolicy = () => {
  const authToken = localStorage.getItem('authToken');
  return (
    <div className='termsMain_cont'>
      <div className="termsTool_cont">
        <div className="toolbarMain_cont">
          <div className="toolbarBrandMain_cont centerElm">
            <div className="toolBrandImg_cont">
              {/* <img src={ZumiBrandImg} alt="brandImg" /> */}
              <h1 className='toolbarBrandName'>ZUMI</h1>
            </div>
          </div>
        </div>
      </div>
      <div className="termsInner_cont">
        <div className="termsSub_cont">
          <p className='termsMainHead'>Privacy Policy</p>
          <div className="terms_cont">
            <p>We are committed to protecting and respecting your privacy. This policy outlines how we manage your personal data, your privacy rights, and how the law protects you when using ZUMI, our marketplace aggregator for resellers. ZUMI provides access to product catalogs, order, and shipping details, and allows users to execute WhatsApp marketing campaigns for product launches.</p>
            <p>By using our website and services, you agree to the collection and use of your personal data in accordance with this Privacy Policy.</p>
          </div>

          <div className="terms_cont">
            <p className='termsBoldPara'><strong>Introduction</strong></p>
            <p>"ZUMI", "we", "us", and "our" refer to ZUMI. This policy applies when you use the ZUMI platform and services. If you have questions regarding this policy, please contact us at <span>privacy@zumi.au</span>.</p>
            <p>Our services may contain links to third-party websites. These websites have their own privacy policies, and we do not accept responsibility for their content or privacy practices. Review their policies before submitting personal data</p>

            <p className='termsBoldPara'><strong>Types of Data we Collect</strong></p>
            <p>We collect different types of personal data from you based on your interaction with the ZUMI platform:</p>
            <p className=''><strong>• Identity Data: </strong>First name, last name, email address.</p>
            <p className=''><strong>• Contact Data: </strong>Email, phone number, shipping address, billing address, business name.</p>
            <p className=''><strong>• Transaction Data: </strong>Details of orders placed, products sourced, payments made, including billing information.</p>
            <p className=''><strong>• Marketing Campaign Data: </strong>WhatsApp marketing campaign data (e.g., recipient lists, campaign details).</p>
            <p className=''><strong>• Technical Data: </strong>IP address, browser type, operating system, and browsing behavior on our platform.</p>
            <p className=''><strong>• Usage Data: </strong>Details of how you interact with our services, including catalog views, order activities, and shipping interactions.</p>
            <p className=''><strong>• Marketing and Communication Data: </strong>Preferences for receiving marketing materials and notifications</p>
            <p className=''><strong>• Profile Data: </strong>Your behavior and interactions on ZUMI to create a tailored user experience.</p>

            <p className='termsBoldPara'><strong>How We Use Your Data</strong></p>
            <p>We process your personal data for the following reasons:</p>
            <p className=''><strong>• Service Provision: </strong>To manage and operate your ZUMI account, provide access to product catalogs, order details, and shipping information.</p>
            <p className=''><strong>• WhatsApp Marketing: </strong>To help you create and execute WhatsApp marketing campaigns.</p>
            <p className=''><strong>• Transaction Management: </strong>To manage orders, payments, and shipping</p>
            <p className=''><strong>• Communication: </strong>To send notifications, updates, and marketing communications (with your consent).</p>
            <p className=''><strong>• Platform Improvement: </strong>To analyze usage data to enhance user experience and improve ZUMI.</p>
            <p className=''><strong>• Compliance: </strong>To comply with legal and regulatory obligations.</p>
            <p>We rely on the following lawful bases to process your data: </p>
            <p>• Your consent</p>
            <p>• Contractual obligations</p>
            <p>• Legitimate business interests</p>
            <p>• Legal compliance</p>

            <p className='termsBoldPara'><strong>Sharing Your Data</strong></p>
            <p className=''><strong>• Service Providers: </strong>To help us deliver ZUMI services (e.g., payment processors, shipping providers).</p>
            <p className=''><strong>• Business Partners: </strong>If you opt to integrate third-party apps for additional functionalities.</p>
            <p className=''><strong>• Legal Authorities: </strong>If required by law or for the establishment, defense, or exercise of legal claims.</p>
            <p className=''><strong>• Mergers and Acquisitions: </strong>In case of business transfers.</p>
            <p>We do not sell your personal data to third parties for marketing purposes.</p>

            <p className='termsBoldPara'><strong>International Transfers</strong></p>
            <p>We may transfer your personal data outside of your country for processing. In such cases, we ensure appropriate safeguards are in place to protect your information in accordance with data protection laws.</p>

            <p className='termsBoldPara'><strong>Data Security</strong></p>
            <p>We use appropriate security measures to protect your personal data. However, no method of transmission over the internet or method of electronic storage is 100% secure. We cannot guarantee absolute security.</p>

            <p className='termsBoldPara'><strong>Data Retention</strong></p>
            <p>We retain your personal data only for as long as necessary to fulfill the purposes outlined in this policy, including satisfying legal, accounting, or reporting requirements.</p>

            <p className='termsBoldPara'><strong>Your Rights</strong></p>
            <p>You have the following rights regarding your personal data:</p>
            <p>• Right to access</p>
            <p>• Right to correction</p>
            <p>• Right to erasure</p>
            <p>• Right to restrict processing</p>
            <p>• Right to data portability</p>
            <p>• Right to withdraw consent (if processing is based on consent)</p>
            <p>To exercise any of these rights, contact us at <span>privacy@zumi.au</span>.</p>

            <p className='termsBoldPara'><strong>Contact Us</strong></p>
            <p>If you have questions regarding this policy or your data, please contact us at <span>privacy@zumi.au</span> </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy;
